import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/d-do-s-simulation-dashboard/components/SimulationDashboard.tsx");
